import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../../axiosinterceptor";

const coder_screen_get_api = "/coder_workspace_episode_data";
const coder_stats_api = "/coder_workspace_stats";
const coder_search_api = "/coding_screen_workflow_get_dashboard_data_bysearch";
const user_preference_check_api =
  "/check_user_has_code_accelerate_assist_permission";
// Async thunk to fetch episode,queues data
const coder_screen_sidebar_queues = "/coder_workspace_queues";
const coder_screen_cards = "/coder_workspace_cards"
const getCdqHistoryResponseApi = "/get_cdq_history_response"
const getClinicianResponseApi = "/get_clinican_response";
export const fetchCodersData = createAsyncThunk(
  "queue/fetchEpisodes",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(coder_screen_get_api, payload);

      // console.log("Coder API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list",
      );
    }
  },
);
export const fetchStatsData = createAsyncThunk(
  "queue/fetchStatsData",
  async (payload, thunkAPI) => {
    try {
      // const response = await axiosInstance.post(coder_stats_api, payload);
      const response = await axiosInstance.post("coder_workspace_stats", payload);

      // console.log("Coder stats Response",payload);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list",
      );
    }
  },
);
export const fetchCdqHistoryResponse = createAsyncThunk(
  "queue/fetchCdqHistoryResponse",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        getCdqHistoryResponseApi,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching CDQ history:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch CDQ history",
      );
    }
  },
);
export const fetchClinicianResponse = createAsyncThunk(
  "queue/fetchClinicianResponse",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        getClinicianResponseApi,
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching clinician response:", error);

      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch clinician response"
      );
    }
  }
);
export const fetchSearchedCoderDetails = createAsyncThunk(
  "queue/fetchSearchedCoderDetails",
  async ({ searchedTerm, pageNumber }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${coder_search_api}?search=${searchedTerm}&page=${pageNumber}`,
      );
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list",
      );
    }
  },
);
export const fetchUserPreferences = createAsyncThunk(
  "queue/fetchUserPreferences",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(user_preference_check_api);
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list",
      );
    }
  },
);
export const getQueueFilterOptions = createAsyncThunk(
  "/getQueueFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/coder_queue_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getCoderSidebarQueues = createAsyncThunk(
  "/getCoderSidebarQueues",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        coder_screen_sidebar_queues,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getCoderViewCards = createAsyncThunk(
  "/getCoderViewCards",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        coder_screen_cards,
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching coder cards options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

const defaultcoderFilter = {
  separation_date_from: null,
  separation_date_to: null,
  admission_date_from: null,
  admission_date_to: null,
  speciality: [],
  queue: [],
  status: [],
  page_number: 1,
  // page_size: 10,
  priority: [],
  medical_record_number: [],
  episode_identifier: [],
  health_fund_contract: [],
  los: [],
  los_op: "gtlt",
  drg_code: [],
  is_user_specific: true,
  sort_by: [],
  sort_order: [],
   is_global_search: false,
};
const CoderScreenSlice = createSlice({
  name: "coderscreenqueue",
  initialState: {
    codersData: [],
    loadingCodersData: false,
    errorCodersData: null,
    queueFiltersData: [],
    loadingQueueFiltersData: null,
    errorQueueFiltersData: [],
    statsData: [],
    loadingStatsData: false,
    errorStatsData: null,
    codersSearchedData: [],
    loadingcodersSearchedData: false,
    errorscodersSearchedData: null,
    preferencesData: [],
    loadingPreferencesData: false,
    errorsPreferencesData: null,
    coderQueuesData: [],
    // loadingCoderQueuesData:false,
    // errorsCoderQueuesData:null,
      cdqHistoryData: [],
    loadingCdqHistoryData: false,
    errorCdqHistoryData: null,

    clinicianResponseData: null,
loadingClinicianResponse: false,
errorClinicianResponse: null,
    queueFilterOptions: {
      pageNumber: 0,
      data: [],
      loading: false,
      error: null,
      hasMore: true,
      search: "",
    },
    queueSidebarOptions: {
      loading: false,
      data: [],
      error: null,
    },
    codercardOptions: {
      loading: false,
      data: [],
      error: null,
    },
    coderFilter: {
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      speciality: [],
      queue: [],
      status: [],
      page_number: 1,
      // page_size: 10,
      priority: [],
      medical_record_number: [],
      episode_identifier: [],
      health_fund_contract: [],
      los: [],
      los_op: "",
      drg_code: [],
      is_user_specific: true,
      sort_by: [],
      sort_order: [],
      is_global_search: false,
    },
  },
  reducers: {
    resetSearchedCodersData: (state) => {
      state.codersSearchedData = [];
      state.loadingcodersSearchedData = false;
      state.errorscodersSearchedData = null;
    },
    resetCoderFilters: (state) => {
      state.coderFilter = {
        separation_date_from: null,
        separation_date_to: null,
        admission_date_from: null,
        admission_date_to: null,
        speciality: [],
        queue: [],
        status: [],
        page_number: 1,
        // page_size: 10,
        priority: [],
        medical_record_number: [],
        episode_identifier: [],
        health_fund_contract: [],
        los: [],
        los_op: "",
        drg_code: [],
        is_user_specific: true,
        sort_by: [],
        sort_order: [],
        is_global_search: false,
      };
    },
    setQueueFilterSearch: (state, action) => {
      state.queueFilterOptions.search = action.payload;
    },
    updateUserAssginedFilters: (state, action) => {
      state.coderFilter = {
        ...state.coderFilter,
        ...action.payload,
      };
    },
    resetFilterQueue(state, action) {
      const key = action.payload;
      state[key].search = "";
      state[key].data = [];
      state[key].pageNumber = 1;
      state[key].hasMore = true;
      state[key].loading = false;
    },
      resetCdqHistoryData: (state) => {
      state.cdqHistoryData = [];
      state.loadingCdqHistoryData = false;
      state.errorCdqHistoryData = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Queue List
      .addCase(fetchCodersData.pending, (state) => {
        state.loadingCodersData = true;
        state.errorCodersData = null;
      })
      .addCase(fetchCodersData.fulfilled, (state, action) => {
        state.loadingCodersData = false;
        state.codersData = action.payload;
      })
      .addCase(fetchCodersData.rejected, (state, action) => {
        state.loadingCodersData = false;
        state.errorCodersData = action.payload;
      })
      // Fetch CoderStats Data
      .addCase(fetchStatsData.pending, (state) => {
        state.loadingStatsData = true;
        state.errorStatsData = null;
      })
      .addCase(fetchStatsData.fulfilled, (state, action) => {
        state.loadingStatsData = false;
        state.statsData = action.payload;
      })
      .addCase(fetchStatsData.rejected, (state, action) => {
        state.loadingStatsData = false;
        state.errorStatsData = action.payload;
      })
      .addCase(fetchSearchedCoderDetails.pending, (state) => {
        state.loadingcodersSearchedData = true;
        state.errorscodersSearchedData = null;
      })
      .addCase(fetchSearchedCoderDetails.fulfilled, (state, action) => {
        state.loadingcodersSearchedData = false;
        state.codersSearchedData = action.payload;
      })
      .addCase(fetchSearchedCoderDetails.rejected, (state, action) => {
        state.loadingcodersSearchedData = false;
        state.errorscodersSearchedData = action.payload;
      })
      //fetch preferences
      .addCase(fetchUserPreferences.pending, (state) => {
        state.loadingPreferencesData = true;
        state.errorsPreferencesData = null;
      })
      .addCase(fetchUserPreferences.fulfilled, (state, action) => {
        state.loadingPreferencesData = false;
        state.preferencesData = action.payload;
      })
      .addCase(fetchUserPreferences.rejected, (state, action) => {
        state.loadingPreferencesData = false;
        state.errorsPreferencesData = action.payload;
      })
      .addCase(getQueueFilterOptions.pending, (state) => {
        state.queueFilterOptions.loading = true;
        state.queueFilterOptions.error = null;
      })
      .addCase(getQueueFilterOptions.fulfilled, (state, action) => {
        state.queueFilterOptions.loading = false;
        const newQueues = action.payload?.queues?.data || [];
        if (action.payload.page_number === 1) {
          state.queueFilterOptions.data = newQueues;
        } else {
          state.queueFilterOptions.data = [
            ...state.queueFilterOptions.data,
            ...newQueues,
          ];
        }
        const isValidPage = action.payload?.queues?.has_more ?? false;
        state.queueFilterOptions.hasMore = isValidPage;
        state.queueFilterOptions.pageNumber = action.payload.page_number;
      })
      .addCase(getQueueFilterOptions.rejected, (state, action) => {
        state.queueFilterOptions.loading = false;
        state.queueFilterOptions.hasMore = false;
        state.queueFilterOptions.error = action.payload;
      }).
      // coder sidebar queues
      addCase(getCoderSidebarQueues.pending, (state) => {
        state.queueSidebarOptions.loading = true;
        state.queueSidebarOptions.error = null;
      })
      .addCase(getCoderSidebarQueues.fulfilled, (state, action) => {
        state.queueSidebarOptions.loading= false;
        state.queueSidebarOptions.data = action.payload;
      })
      .addCase(getCoderSidebarQueues.rejected, (state, action) => {
        state.queueSidebarOptions.loading= false;
        state.queueSidebarOptions.error = action.payload;
      }).
      // coder cards options
      addCase(getCoderViewCards.pending, (state) => {
        state.codercardOptions.loading = true;
        state.codercardOptions.error = null;
      })
      .addCase(getCoderViewCards.fulfilled, (state, action) => {
        state.codercardOptions.loading= false;
        state.codercardOptions.data = action.payload;
      })
      .addCase(getCoderViewCards.rejected, (state, action) => {
        state.codercardOptions.loading= false;
        state.codercardOptions.error = action.payload;
      })
       // Fetch CDQ Response History
       // Fetch CDQ Response History
      .addCase(fetchCdqHistoryResponse.pending, (state) => {
        state.loadingCdqHistoryData = true;
        state.errorCdqHistoryData = null;
      })
      .addCase(fetchCdqHistoryResponse.fulfilled, (state, action) => {
        state.loadingCdqHistoryData = false;
        // Each page fetch replaces the currently displayed page of results.
        state.cdqHistoryData = action.payload;
      })
      .addCase(fetchCdqHistoryResponse.rejected, (state, action) => {
        state.loadingCdqHistoryData = false;
        state.errorCdqHistoryData = action.payload;
      })

      .addCase(fetchClinicianResponse.pending, (state) => {
  state.loadingClinicianResponse = true;
  state.errorClinicianResponse = null;
  state.clinicianResponseData = null;
})

.addCase(fetchClinicianResponse.fulfilled, (state, action) => {
  state.loadingClinicianResponse = false;
  state.clinicianResponseData = action.payload;
})

.addCase(fetchClinicianResponse.rejected, (state, action) => {
  state.loadingClinicianResponse = false;
  state.errorClinicianResponse = action.payload;
})
  },
});
export const {
  resetSearchedCodersData,
  resetCoderFilters,
  updateUserAssginedFilters,
  // resetCoderProvisionalDrg,
  // resetEpisodeIdsCoderData,
  setQueueFilterSearch,
  resetFilterQueue,
  resetCdqHistoryData
} = CoderScreenSlice.actions;
export default CoderScreenSlice.reducer;
